import i18n from 'client/i18n'
import { createContainerStructure } from 'client/utils/createStructureUtils'
import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { WebsiteLibraryElementsCreator } from 'src/editor/pages/website/website-library-elements-creator'
import { SendFormActionButtonEntityInterface } from 'src/shared/entities/button/send-form.action-button.schema'
import { LibraryElementEnum } from 'src/shared/enums/LibraryElementEnum'

const elementsCreator = new WebsiteLibraryElementsCreator()

export const createWebsitePopupFromLibrary = (locale: string) => {
  const fixedT = i18n.getFixedT(locale)

  const popupEntity = elementsCreator[LibraryElementEnum.LibraryPopup]()

  const { structure, descendantEntity } = createContainerStructure(
    popupEntity,
    locale,
    0,
  )

  const headerText = elementsCreator[LibraryElementEnum.LibraryHeadline](
    descendantEntity.id,
    fixedT('entities.text.subscribe_text'),
  )
  headerText.textAlign = 'center'

  const input = elementsCreator[LibraryElementEnum.LibraryField](
    descendantEntity.id,
    descendantEntity.masterBlockId,
    {
      slug: FieldSlugEnum.Email,
      placeholder: 'Email',
    },
  )

  const button = elementsCreator[LibraryElementEnum.LibraryButton](
    descendantEntity.id,
    fixedT('entities.button.default_text'),
    fixedT('entities.button.default_sub_text'),
    descendantEntity.masterBlockId,
  ) as SendFormActionButtonEntityInterface
  button.margin = {
    marginTop: 15,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
  }
  button.redirectionType = RedirectionTypesEnum.customUrl

  const caption = elementsCreator[LibraryElementEnum.LibraryText](
    descendantEntity.id,
    undefined,
    fixedT('entities.text.hate_spam'),
  )
  caption.backgroundColor = 'rgba(155, 155, 155, 0)'
  caption.fontSize = 15
  caption.margin = {
    marginTop: 10,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 0,
  }
  caption.textAlign = 'center'

  return {
    ascendantId: popupEntity.id,
    structure: {
      ...structure,
      [descendantEntity.id]: {
        ...descendantEntity,
        childIds: [headerText.id, input.id, button.id, caption.id],
      },
      [popupEntity.id]: {
        ...popupEntity,
        childIds: [structure[descendantEntity.parentId as string].id],
      },
      [headerText.id]: headerText,
      [input.id]: input,
      [button.id]: button,
      [caption.id]: caption,
    },
  }
}
